import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BoxService } from 'src/app/service/box.service';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { Box } from './box';

@Component({
  selector: 'app-box',
  templateUrl: './box.component.html',
  styleUrls: ['./box.component.scss']
})
export class BoxComponent implements OnInit {

  formulario: FormGroup;
  boxs: Box[] = [];
  ordemColunasTabela = ['id', 'name','pixBalance', 'caixaBalance','cartaoBalance', 'active','excluir', 'editar'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100]; 
  mensagemErros: String[] = []; 
  
  
  constructor(
    private boxService: BoxService,
    private formBilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.montarFormulario();
    this.listarClients(this.pagina, this.tamanho);
  }

  submit() {
    //pegar os dados do formulário
    const formValues = this.formulario.value;
    // cria e adiciona no objeto
    const box: Box = new Box(
      formValues.id,
      formValues.name,
      formValues.pixBalance,
      formValues.caixaBalance,
      formValues.cartaoBalance,
      formValues.createdAt, 
      formValues. active,);

    if (formValues.id) {
      this.boxService.update(box).subscribe(resposta => {
        this.listarClients(this.pagina, this.tamanho);
        // exibir mensagem snackbar
        this.snackBar.open('Caixa alterado com sucesso!', 'Sucesso', {
          duration: 2000
        })
        //limpar formulário
        this.formulario.reset();
      }, errorResponse => {
        // exibir mensagem snackbar
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000
        })
      })
    } else {
      // cria e adiciona no objeto
      this.boxService.save(box).subscribe(resposta => {
        this.listarClients(this.pagina, this.tamanho);
        // exibir mensagem snackbar
        this.snackBar.open('Caixa salvo com sucesso!', 'Sucesso', {
          duration: 2000
        })
        //limpar formulário
        this.formulario.reset();
      }, errorResponse => {
        // exibir mensagem snackbar
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000
        })
      })
    }
  }

  montarFormulario() {
    this.formulario = this.formBilder.group({
      id: [null, Validators.nullValidator],
      name: [null, [Validators.minLength(3), Validators.maxLength(250)]],
      pixBalance: [null, Validators.nullValidator],
      caixaBalance: [null, Validators.nullValidator],
      cartaoBalance: [null, Validators.nullValidator],
      createdAt: [null, Validators.nullValidator],
      active: [null, Validators.nullValidator]
    })
  }

  limparFormulario() {
    this.formulario.reset();    
  }


  listarClients(pagina: number, tamanho: number) {
    this.boxService.list(pagina, tamanho).subscribe((response) => {
      this.boxs = response.content; 
      this.totalElementos = response.totalElements;
      this.pagina = response.number;
    });
  }

  private excluir(id: number) {
    this.boxService.delete(id).subscribe((response) => {
      this.ngOnInit();
      this.mensagemErros = [];
      this.snackBar.open('Caixa excluido com sucesso!', 'Sucesso', {
        duration: 2000
      })
    }, errorResponse => {
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
    })
  }

  editar(id: number) {
    this.boxService.findClientById(id).subscribe((response) => {
      this.formulario.controls.id.setValue(id);
      this.formulario.controls.name.setValue(response.name);
      this.formulario.controls.pixBalance.setValue(response.pixBalance);
      this.formulario.controls.caixaBalance.setValue(response.caixaBalance);
      this.formulario.controls.cartaoBalance.setValue(response.cartaoBalance);
      this.formulario.controls.createdAt.setValue(response.createdAt); 
      this.formulario.controls.active.setValue(response.active);     
    })
  }

  //chamar a paginação
  paginar(event: PageEvent) {
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.listarClients(this.pagina, this.tamanho);
  }

  openDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmaDeleteComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.excluir(id);
      }
    });
  }
}
